import {request,newVue,requestMsg} from "./request";
export {newVue}

export function getTermsList(pageNum,pageSize) {
  return request({
    url: '/terms/getTermsList',
    params: {
      pageNum: pageNum,
      pageSize: pageSize
    }
  })
}

export function updateTerms(version) {
  return requestMsg({
    url: '/terms/updateTerms',
    data: JSON.stringify(version),
    method: "POST",
    headers : {"Content-Type" : "application/json;charset=utf-8"},
  })
}

export function getTermsById(id) {
  return requestMsg({
    url: '/terms/getTermsById',
    params: {
      id: id,
    }
  })
}

